import React from 'react';
import CaseStudiesSection from '../components/CaseStudiesSection';

export default function CaseStudiesPage() {
  return (
    <div className="page-container">
      <section className="page-header section-dark">
        <div className="section-content">
          <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
            <div className="section-eyebrow">Proven Results</div>
            <h1 style={{ fontSize: '48px', marginBottom: '24px' }}>Client Success Stories</h1>
            <p style={{ fontSize: '20px', color: 'var(--text-secondary)' }}>
              Real outcomes from organizations that partnered with IronQuill to win competitive contracts.
            </p>
          </div>
        </div>
      </section>

      <CaseStudiesSection />
    </div>
  );
}
